import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import * as Icons from "lucide-react";
import { Clock, ArrowRight, BookOpen } from "lucide-react";

export default function Topics() {
  const [topics, setTopics] = useState([]);

  useEffect(() => {
    api.get("/topics").then((r) => setTopics(r.data.topics)).catch(() => {});
  }, []);

  return (
    <div className="space-y-8" data-testid="topics-root">
      <div>
        <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl">Topics</h1>
        <p className="mt-2 text-sm text-slate-400">Concise lessons in the order they usually appear in class.</p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {topics.map((t, i) => {
          const Icon = Icons[t.icon] || BookOpen;
          const diffColor =
            t.difficulty === "Beginner" ? "text-lime-300 border-lime-400/30" :
            t.difficulty === "Intermediate" ? "text-cyan-300 border-cyan-400/30" :
            "text-fuchsia-300 border-fuchsia-400/30";
          return (
            <Link
              key={t.id}
              to={`/topics/${t.id}`}
              data-testid={`topic-card-${t.id}`}
              className="group flex flex-col rounded-md border border-white/10 bg-black/40 p-6 transition-transform duration-150 hover:-translate-y-0.5 hover:border-cyan-400/40 hover:shadow-[0_0_20px_rgba(0,229,255,0.15)]"
              style={{ animationDelay: `${i * 40}ms` }}
            >
              <div className="mb-6 flex items-center justify-between">
                <div className="grid h-10 w-10 place-items-center rounded-md border border-cyan-400/30 bg-cyan-500/5 text-cyan-300">
                  <Icon size={18} />
                </div>
                <span className={`rounded-full border px-2 py-0.5 text-[10px] uppercase tracking-widest ${diffColor}`}>
                  {t.difficulty}
                </span>
              </div>
              <h3 className="font-display text-xl font-semibold text-white">{t.title}</h3>
              <p className="mt-2 grow text-sm text-slate-400">{t.summary}</p>
              <div className="mt-6 flex items-center justify-between text-xs text-slate-500">
                <div className="flex items-center gap-1 font-mono-num">
                  <Clock size={12} /> {t.minutes} min
                </div>
                <ArrowRight size={14} className="text-slate-400 transition-transform group-hover:translate-x-1 group-hover:text-cyan-300" />
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
